import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e2734ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "auth-modal"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "align-center l-font-size" }, "Пароль успешно изменен")
], -1))
const _hoisted_3 = {
  key: 2,
  class: "auth-modal"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "align-center l-font-size" }, " Вы успешно зарегистрировались, логин и пароль отправлен вам на почту ")
], -1))
const _hoisted_5 = {
  key: 3,
  class: "auth-modal"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "align-center l-font-size" }, " Инструкция по восстановлению пароля отправлена вам на почту ", -1))
const _hoisted_7 = [
  _hoisted_6
]

import { computed, onMounted, onUnmounted, ref, Ref } from 'vue';
import { useUserStore } from '@/store/modules/user';
import { useRoute, useRouter } from 'vue-router';
import LoginModal from '@/components/AuthComponents/LoginModal.vue';
import PasswordRecovery from '@/components/AuthComponents/PasswordRecovery.vue';
import PasswordRestore from '@/components/AuthComponents/PasswordRestore.vue';
import RegistrationModal from '@/components/AuthComponents/RegistrationModal.vue';
import { useAppStore } from '@/store/modules/app';

type modalsTypes =
  | 'login'
  | 'registration'
  | 'passwordRecovery'
  | 'successPasswordRecovery'
  | 'successRegistration'
  | 'successPasswordRestore';
type ModalTitlesType = {
  [key in modalsTypes]?: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'AuthModal',
  setup(__props) {

const activeModal: Ref<modalsTypes | undefined> = ref(undefined);
const modalTitles: ModalTitlesType = {
  login: 'Войти',
  registration: 'Регистрация на БЕТА версию',
  passwordRecovery: 'Восстановление пароля',
};

const router = useRouter();

const showPassRestoreModal = computed((): boolean => {
  return !useUserStore().getIsLogin() && useRoute()?.name === 'passwordRestore';
});

const closeModal = () => {
  useAppStore().closeAuthModal();
};

const changeModalType = (type: modalsTypes) => {
  activeModal.value = type;
};

const gotoLogin = () => {
  useAppStore().openAuthModal();
  activeModal.value = 'login';
  router.push({ name: 'main' });
};

onMounted(() => {
  if (useRoute()?.name !== 'passwordRestore') {
    activeModal.value = 'login';
  }
  document.body.classList.add('overflow-hidden');
});
onUnmounted(() => {
  document.body.classList.remove('overflow-hidden');
});

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(LoginModal, {
      hideScroll: false,
      "show-modal": activeModal.value === 'login',
      onClose: _cache[0] || (_cache[0] = ($event: any) => (closeModal())),
      onShowPasswordRecoveryModal: _cache[1] || (_cache[1] = ($event: any) => (changeModalType('passwordRecovery'))),
      onShowRegistrationModal: _cache[2] || (_cache[2] = ($event: any) => (changeModalType('registration')))
    }, null, 8, ["show-modal"]),
    _createVNode(RegistrationModal, {
      hideScroll: false,
      "show-modal": activeModal.value === 'registration',
      onClose: _cache[3] || (_cache[3] = ($event: any) => (closeModal())),
      onSuccessRegistration: _cache[4] || (_cache[4] = ($event: any) => (changeModalType('successRegistration'))),
      onShowLoginModal: _cache[5] || (_cache[5] = ($event: any) => (changeModalType('login')))
    }, null, 8, ["show-modal"]),
    _createVNode(_component_base_modal, {
      "hide-title": !modalTitles[activeModal.value]?.length,
      hideScroll: false,
      "show-modal": 
      activeModal.value === 'passwordRecovery' ||
      activeModal.value === 'successRegistration' ||
      activeModal.value === 'successRegistration' ||
      activeModal.value === 'successPasswordRestore' ||
      activeModal.value === 'successPasswordRecovery'
    ,
      title: modalTitles[activeModal.value],
      onClose: _cache[10] || (_cache[10] = ($event: any) => (closeModal()))
    }, {
      content: _withCtx(() => [
        (activeModal.value === 'passwordRecovery')
          ? (_openBlock(), _createBlock(PasswordRecovery, {
              key: 0,
              onClose: _cache[6] || (_cache[6] = ($event: any) => (changeModalType('login'))),
              onShowSuccessMessage: _cache[7] || (_cache[7] = ($event: any) => (changeModalType('successPasswordRecovery')))
            }))
          : (activeModal.value === 'successPasswordRestore')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", null, [
                  _createVNode(_component_base_button, {
                    "all-block-width": "",
                    height: "40",
                    text: "Войти",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (changeModalType('login')))
                  })
                ])
              ]))
            : (activeModal.value === 'successRegistration')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("div", null, [
                    _createVNode(_component_base_button, {
                      "all-block-width": "",
                      height: "40",
                      text: "Войти",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (changeModalType('login')))
                    })
                  ])
                ]))
              : (activeModal.value === 'successPasswordRecovery')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["hide-title", "show-modal", "title"]),
    _createVNode(_component_base_modal, {
      "show-modal": showPassRestoreModal.value,
      "hide-title": "",
      onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.push({ name: 'main' })))
    }, {
      content: _withCtx(() => [
        _createVNode(PasswordRestore, { onClose: gotoLogin })
      ]),
      _: 1
    }, 8, ["show-modal"])
  ], 64))
}
}

})